 <template>
    <div class="Menu__panel-wrapper sm:shadow z-30 w-full sm:w-64"
        :class="{'isActive': isActive}"
        :style="[style_wrapperStyle, isActive ? style_wrapperActiveStyle : {}]"
    >

        <!-- prev -->
        <MenuPanel
            :list="content_prevItem"
            :functionalityStyle="style_panelStyle"
            :positionStyle="panel_prevPositionStyle"
            :isTranslating="isTranslating"
            :transitionStyle="style_transitionStyle"
            :showHeaderArrow="prevItemHasParent"
        />

        <!-- staging -->
        <MenuPanel
            :list="content_currentItem"
            :functionalityStyle="style_panelStyle"
            :positionStyle="panel_stagingPositionStyle"
            :isTranslating="isTranslating"
            :transitionStyle="style_transitionStyle"
            :showHeaderArrow="currentItemHasParent"
            :handleHeaderClicked="clickPrevItem"
            :handleItemClicked="clickNextItem"
            :loading="fetchingChildren"
        />

        <!-- next -->
        <MenuPanel
            :list="content_nextItem"
            :functionalityStyle="style_panelStyle"
            :positionStyle="panel_nextPositionStyle"
            :isTranslating="isTranslating"
            :transitionStyle="style_transitionStyle"
            :showHeaderArrow="true"
        />
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import functionalityStyle from '@/mixins/functionalityStyle.mixin';
    import panelControl from '@/mixins/panelControl.mixin';
    import contentControl from '@/mixins/contentControl.mixin';
    import Http from '@/helpers/Http';

    export default {
        name: "left-side",
        mixins: [
            functionalityStyle,
            panelControl,
            contentControl,
        ],
        components: {
            MenuPanel: () => import('@/components/MenuPanel')
        },
        data() {
            return {
                isActive: true,
                isTranslating: false,
                panelWidth: '100%',
                menuOpenSpeed: 350,
                menuSwitchSpeed: 300,
                fetchingChildren: false,
            };
        },        
        computed: {
            ...mapGetters({
                source: 'leftSideRoutes',
                user: 'auth/user',
            }),
            currentItemHasParent() {
                return this.content_parentStack.length >= 1;
            },
            prevItemHasParent() {
                return this.content_parentStack.length >= 2;
            },
        },
        mounted() {
            this.$store.commit('addLeftSideRoutes', this.$router.options.routes);
            this.addPBXWareMenu();        
        },
        methods: {
            addPBXWareMenu() {
                this.$store.dispatch('pbxware/getTenants')
                    .then(({ data }) => {
                        let menu = {
                            path: '/pbxware',
                            component: () => import('@/views/pbxware/Index'),
                            children: [],
                            meta: {
                                auth: true,
                                title: 'PBXWare',
                                label: 'PBXWare',
                                group: 'leftSidebar',
                                permission: 'Manage PBXWare',
                            }
                        }

                        for (let i in data) {
                            if (data.hasOwnProperty(i)) {
                                const tenant_name = `${data[i].name} (${data[i].tenantcode})`;
                                menu.children.push({
                                    path: `${data[i].name}`,
                                    name: `pbxware-${data[i].name}`,
                                    component: () => import('@/views/pbxware/tenant/Index.vue'),
                                    children: [
                                        {
                                            path: 'extensions',
                                            name: `pbxware-${data[i].name}-extensions-extensions`,
                                            component: () => import('@/views/pbxware/tenant/extension/System.vue'),
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - Extensions`,
                                                label: 'Extensions',
                                                serverId: i,
                                            }
                                        },
                                        {
                                            path: 'ring-groups',
                                            name: `pbxware-${data[i].name}-extensions-ring-groups`,
                                            component: () => import('@/views/pbxware/tenant/extension/RingGroups.vue'),
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - Ring Groups Extensions`,
                                                label: 'Ring Groups',
                                                serverId: i,
                                            }
                                        },
                                        {
                                            path: 'paging-groups',
                                            name: `pbxware-${data[i].name}-extensions-paging-groups`,
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - Paging Groups Extensions`,
                                                label: 'Paging Groups',
                                                serverId: i,
                                            }
                                        },
                                        {
                                            path: 'departments',
                                            name: `pbxware-${data[i].name}-extensions-departments`,
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - Departments Extensions`,
                                                label: 'Departments',
                                                serverId: i,
                                            }
                                        },
                                        {
                                            path: 'hot-desking',
                                            name: `pbxware-${data[i].name}-extensions-hot-desking`,
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - Hot Desking Extensions`,
                                                label: 'Hot Desking',
                                                serverId: i,
                                            }
                                        },
                                        {
                                            path: 'dids',
                                            name: `pbxware-${data[i].name}-dids`,
                                            component: () => import('@/views/pbxware/tenant/DIDs.vue'),
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - DIDs`,
                                                label: 'DIDs',
                                                serverId: i,
                                                permission: 'Manage PBXWare DID'
                                            }
                                        },
                                        {
                                            path: 'ivr',
                                            name: `pbxware-${data[i].name}-ivr`,
                                            component: () => import('@/views/pbxware/tenant/IVR.vue'),
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - IVR`,
                                                label: 'IVR',
                                                serverId: i,
                                                permission: 'Manage PBXWare IVR'
                                            }
                                        },
                                        {
                                            path: 'cdr',
                                            name: `pbxware-${data[i].name}-cdr`,
                                            component: () => import('@/views/pbxware/tenant/CDR.vue'),
                                            meta: {
                                                auth: true,
                                                title: `${tenant_name} - CDR`,
                                                label: 'CDR',
                                                serverId: i,
                                                permission: 'Manage PBXWare CDR'
                                            }
                                        },
                                        {
                                            path: 'invoice',
                                            name: `pbxware-${data[i].name}-invoice`,
                                            meta: {
                                                auth: true,
                                                label: 'Invoice',
                                                permission: 'Manage PBXWare CDR',
                                                modal: () => import('@/views/pbxware/modals/GenerateInvoice.vue'),
                                                tenantName: data[i].name,
                                                tenantId: i,
                                            }
                                        }
                                    ],
                                    meta: {
                                        auth: true,
                                        title: tenant_name,
                                        label: tenant_name,
                                        icon: () => import('@/icons/Public'),
                                    }
                                })
                            }
                        }

                        this.$store.commit('addLeftSideRoutes', [menu]);
                        this.$router.addRoutes([menu]);
                        this.content_currentItem = this.source;
                    })
            },
            clickBurger() {
                this.isActive = !this.isActive;
            },
            clickShadow() {
                this.isActive = false;
            },
            clickNextItem(targetItem) {
                if ((this.isTranslating || !targetItem.children) && (!targetItem.meta.children)) {
                    if (targetItem.meta.modal) {
                        this.$store.commit('setModal', {
                            path: targetItem.path,
                            component: targetItem.meta.modal,
                            route: targetItem, 
                        });
                        this.$store.commit('setShowModal', true);
                        return;
                    }

                    if (targetItem.name == 'logout') {
                        this.logout();
                        return;
                    }                    

                    if (targetItem.meta.url) {
                        window.open(targetItem.meta.url, '_blank');
                        return;
                    }

                    if (this.$route.name !== targetItem.name) {
                        this.$router.push({name: targetItem.name});
                    }

                    return;
                }

                if (targetItem.meta.children && targetItem.children.length == 0) {
                    this.fetchingChildren = true;
                    Http.get(targetItem.meta.children.path)
                        .then(({ data }) => {
                            this.fetchingChildren = false;
                            this.$store.commit('updateLeftSideRoutesChildren', {
                                parent: targetItem, 
                                children: data,
                                router: this.$router,
                            });
                        })
                        .catch(({ response }) => {
                            this.fetchingChildren = false;
                        })
                }

                this.slideToNext(targetItem);
            },
            clickPrevItem() {
                this.fetchingChildren = false;

                if (this.isTranslating || !this.currentItemHasParent) {
                    return;
                }
                this.slideToPrev();
            },
            /*
             * main part of core
             * definite of how to handle panel sliding and item updating
             */
            slideToNext(targetItem) {
                // set target item as content of next panel
                this.content_setNextItem(targetItem);
                // switch animation on
                this.setTranslating(true);
                // activate panel sliding with animation after `.translating` class has updated to panel dom.
                this.$nextTick(() => {
                    this.panel_slideNext();
                });
                // reset panel position
                this.homingAfterTranslatingNext();
            },
            slideToPrev() {
                // set prev item which is the parent of the current item.
                this.content_setPrevItem();
                // switch animation on
                this.setTranslating(true);
                // activate panel sliding with animation after `.translating` class has updated to panel dom.
                this.$nextTick(() => {
                    this.panel_slideBack();
                });
                // reset panel position
                this.homingAfterTranslatingBack();
            },
            // handle homing after slide animation end
            homingAfterTranslatingNext() {
                setTimeout(() => {
                    // switch off transition state of panel
                    this.setTranslating(false);
                    // push current to parent stack
                    this.content_pushCurrentToParentStack();
                    // homing
                    this.panel_homingPosition(); // reset panel position just like the beginning.
                    this.content_homingItemAfterNext(); // change item between these panels to meet updated panel position.
                }, this.menuSwitchSpeed);
            },
            homingAfterTranslatingBack() {
                setTimeout(() => {
                    this.setTranslating(false);
                    // homing
                    this.panel_homingPosition();
                    this.content_homingItemAfterBack();
                }, this.menuSwitchSpeed);
            },
            // utils
            setTranslating(status) {
                this.isTranslating = status;
            },
            logout() {
                this.$store.commit('setLoading', true);
                this.$store.dispatch('auth/logout')
                    .then(() => {
                        this.$router.push({ name: 'login' })
                        this.$store.commit('setLoading', false)
                    })
                    .catch(() => {
                        this.$store.commit('setLoading', false)
                    })
            }
        }
    }
</script>
